import {createSelector} from "@reduxjs/toolkit";
import rootSelector from "../rootSelector";

const miscellaneousSelector = createSelector(rootSelector, s => s.miscellaneous);

export const metadataSchemaSelector = createSelector(miscellaneousSelector, s => s?.packageMetadataSchema);

export const metadataFetchedSelector = createSelector(miscellaneousSelector, s => s?.packageMetadataFetched);

export const metadataJsonSelector = createSelector(miscellaneousSelector, s => s?.packageMetadataJson);
export const metadataHtmlSelector = createSelector(miscellaneousSelector, s => s?.packageMetadataHtml);
export const metadataUrlSelector = createSelector(miscellaneousSelector, s => s?.packageMetadataUrl);

export const licenseSelector = createSelector(miscellaneousSelector, s => s?.license);

export const redirectUrlSelector = createSelector(miscellaneousSelector, s => s?.redirectUrl);
